import { FC } from 'react';

import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { SPECIAL_DISPLAY_COLORS } from '@telialt/utils/src/eshopConstants';
import { useComponentId } from '@telialt/utils/src/hooks';

import { BadgeComponentProps } from '../model';
import { ColorDotLabel, ColorDotWrapper, Diagonal } from './ColorBadge.styles';

type Props = { color: string; colorName: string } & BadgeComponentProps;

export const ColorBadge: FC<Props> = ({
    onClick,
    color,
    colorName,
    checked,
    disabled,
    disabledLooking,
    dataTest,
    parentUID = '',
}) => {
    const { t } = useTranslations();
    const inputId = 'color-dot' + useComponentId();
    const unavailableId = inputId + '--unavailable';

    const patternUrl =
        (color === SPECIAL_DISPLAY_COLORS.MULTICOLOR && `${IMAGES_PATH}/temp/multicolor-color-badge.svg`) ||
        (color === SPECIAL_DISPLAY_COLORS.TRANSPARENT && `${IMAGES_PATH}/temp/transparent-color-badge.svg`) ||
        undefined;

    return (
        <ColorDotWrapper>
            <input
                id={inputId}
                type="radio"
                name={'color-selection' + parentUID}
                checked={checked}
                disabled={disabled}
                aria-describedby={disabledLooking ? unavailableId : undefined}
                onChange={onClick}
                data-test={dataTest}
            />
            <ColorDotLabel
                htmlFor={inputId}
                aria-label={colorName}
                $color={patternUrl ? undefined : color}
                $patternUrl={patternUrl}
            >
                {disabledLooking && <Diagonal />}
            </ColorDotLabel>
            {disabledLooking && (
                <span id={unavailableId} hidden={true}>
                    {t['eshop.product_page.stock_status.out_of_stock']}
                </span>
            )}
        </ColorDotWrapper>
    );
};
